/**
 * <launch-countdown> — countdown timer for the pre-order / coming-soon launch UI.
 *
 * Rendered by snippets/launch-state.liquid. Framework-free custom element so it
 * auto-initialises on connect and survives Horizon section morphs (variant change
 * re-renders the buy area). See custom-code-padelusa/features/preorder-coming-soon.md.
 *
 * Markup contract:
 *   <launch-countdown data-deadline="<unix-epoch-seconds>">
 *     <span data-cd="days"></span><span data-cd="hours"></span>
 *     <span data-cd="minutes"></span><span data-cd="seconds"></span>
 *   </launch-countdown>
 *
 * When the deadline passes the element gets data-expired="true" (CSS can react).
 * Under prefers-reduced-motion it updates once a minute instead of every second
 * (the snippet hides the seconds unit in that case to avoid a stale readout).
 */
if (!customElements.get('launch-countdown')) {
  customElements.define(
    'launch-countdown',
    class LaunchCountdown extends HTMLElement {
      connectedCallback() {
        const deadline = parseInt(this.getAttribute('data-deadline'), 10);
        if (!deadline || Number.isNaN(deadline)) return;
        this.deadlineMs = deadline * 1000;
        this.parts = {
          days: this.querySelector('[data-cd="days"]'),
          hours: this.querySelector('[data-cd="hours"]'),
          minutes: this.querySelector('[data-cd="minutes"]'),
          seconds: this.querySelector('[data-cd="seconds"]'),
        };
        this.reduced =
          window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.tick();
        if (!this.hasAttribute('data-expired')) {
          this.timer = setInterval(() => this.tick(), this.reduced ? 60000 : 1000);
        }
      }

      disconnectedCallback() {
        if (this.timer) clearInterval(this.timer);
      }

      tick() {
        const diff = this.deadlineMs - Date.now();
        if (diff <= 0) {
          if (this.timer) clearInterval(this.timer);
          this.setAttribute('data-expired', 'true');
          this.paint(0, 0, 0, 0);
          return;
        }
        const total = Math.floor(diff / 1000);
        this.paint(
          Math.floor(total / 86400),
          Math.floor((total % 86400) / 3600),
          Math.floor((total % 3600) / 60),
          total % 60
        );
      }

      paint(d, h, m, s) {
        if (this.parts.days) this.parts.days.textContent = d;
        if (this.parts.hours) this.parts.hours.textContent = this.pad(h);
        if (this.parts.minutes) this.parts.minutes.textContent = this.pad(m);
        if (this.parts.seconds) this.parts.seconds.textContent = this.pad(s);
      }

      pad(n) {
        return n < 10 ? '0' + n : '' + n;
      }
    }
  );
}
